import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LucideAngularModule } from 'lucide-angular';

import { APP_ICONS } from './app.icons';
import { AppLucideIconComponent } from './app-lucide-icon.component';

/**
 * Iconos de la aplicación.
 *
 * Registra el catálogo curado de lucide una sola vez y reexporta el módulo,
 * así cualquier feature obtiene `<lucide-icon>` con un único import y sin
 * repetir el `pick()`.
 *
 * Expone además `<app-lucide-icon>`, que sirve para los iconos cuyo nombre lo
 * elige el usuario: si cae fuera del catálogo lo busca en el set completo.
 *
 * Lucide es la librería de iconos para código nuevo. El iconfont de feather y
 * Font Awesome 4.7 siguen vivos en las pantallas que ya los usaban: conviven
 * sin problema porque lucide es el sucesor de feather y comparten trazo.
 */
@NgModule({
  imports: [CommonModule, LucideAngularModule.pick(APP_ICONS)],
  declarations: [AppLucideIconComponent],
  exports: [LucideAngularModule, AppLucideIconComponent],
})
export class IconsModule {}
